import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("./components/Dashboard"),
      meta: { keepAlive: false },
    },
    {
      path: "/clubs",
      name: "Clubs",
      component: () => import("./components/Clubs"),
      meta: { keepAlive: false },
    },

    {
      path: "/class",
      name: "class",
      component: () => import("./components/ClassList"),
      meta: { keepAlive: true },
    },
    {
      path: "/CreateStudent",
      name: "CreateStudent",
      component: () => import("./components/CreateStudent"),
    },
    {
      path: "/Categories",
      name: "Categories",
      component: () => import("./components/Categories"),
      meta: { keepAlive: true },
    },
    {
      path: "/CreateDate",
      name: "CreateDate",
      component: () => import("./components/CreateDate"),
      meta: { keepAlive: true },
    },

    {
      path: "/Statistic",
      name: "Statistic",
      component: () => import("./components/Statistic"),
      meta: { keepAlive: false },
    },
    {
      path: "/StudentsRegistry",
      name: "StudentsRegistry",
      component: () => import("./components/StudentsRegistry"),
      meta: { keepAlive: false },
    },
    {
      path: "/policy",
      name: "Policy",
      component: () => import("./components/Policy"),
    },
    {
      path: "/Violations",
      name: "Violations",
      component: () => import("./components/Violations"),
      meta: { keepAlive: false },
    },
    {
      path: "/HonorBoard",
      name: "HonorBoard",
      component: () => import("./components/HonorBoard"),
      meta: { keepAlive: false },
    },
    {
      path: "/Achievements",
      name: "Achievements",
      component: () => import("./components/Achievements"),
      meta: { keepAlive: false },
    },
    {
      path: "/Receipt",
      name: "Receipt",
      component: () => import("./components/Receipt"),
      meta: { keepAlive: false },
    },
    {
      path: "/",
      name: "login",
      component: () => import("./components/login").then((m) => m.default),
      meta: { keepAlive: false },
    },
    {
      path: "/GeneralSummary",
      name: "GeneralSummary",

      component: () => import("./components/GeneralSummary"),
      meta: { keepAlive: false },
    },
    {
      path: "/registryChange",
      name: "registryChange",

      component: () => import("./components/registryChange"),
      meta: { keepAlive: false },
    },
    {
      path: "/TableAttendanceDataSummary",
      name: "TableAttendanceDataSummary",
      props: true,

      component: () => import("./components/TableAttendanceDataSummary"),
      meta: { keepAlive: true },
    },
    {
      path: "/OrderCategory",
      name: "OrderCategory",
      props: true,

      component: () => import("./components/OrderCategory"),
      meta: { keepAlive: true },
    },
    {
      path: "/sampleDocuments",
      name: "sampleDocuments",
      props: true,

      component: () => import("./components/sampleDocuments"),
      meta: { keepAlive: true },
    },
    {
      path: "/PostSettings",
      name: "PostSettings",

      component: () => import("./components/PostSettings"),
      meta: { keepAlive: false },
    },
    {
      path: "/FoodCompensation",
      name: "FoodCompensation",
      props: true,

      component: () => import("./components/FoodCompensation"),
      meta: { keepAlive: true },
    },
    {
      path: "/FoodTypeWeekSettings",
      name: "FoodTypeWeekSettings",
      props: true,

      component: () => import("./components/FoodTypeWeekSettings"),
      meta: { keepAlive: false },
    },
    {
      path: "/globalSettings",
      name: "globalSettings",
      props: true,

      component: () => import("./components/globalSettings"),
      meta: { keepAlive: false },
    },
    {
      path: "/DataStudents",
      name: "DataStudents",
      props: true,

      component: () => import("./components/DataStudents"),
      meta: { keepAlive: false },
    },
    {
      path: "/inventoryControlPanel",
      name: "inventoryControlPanel",
      props: true,

      component: () => import("./components/inventoryControlPanel"),
      meta: { keepAlive: false },
    },
    {
      path: "/clanedarEvents",
      name: "clanedarEvents",
      props: true,

      component: () => import("./components/clanedarEvents"),
      meta: { keepAlive: false },
    },
    {
      path: "/AIC",
      name: "AIC",
      props: true,
      component: () => import("./components/AIC/AIC_page"),
      meta: { keepAlive: false },
    },
    {
      path: "/BUS_info",
      name: "BUS_info",
      props: true,
      component: () => import("./components/BUS_info"),
      meta: { keepAlive: false },
    },
    {
      path: "/EmotionalStateChecklist",
      name: "EmotionalStateChecklist",
      props: true,
      component: () => import("./components/EmotionalStateChecklist"),
      meta: { keepAlive: false },
    },

    {
      path: "/RiskZonesChecklist",
      name: "RiskZonesChecklist",
      props: true,
      component: () => import("./components/RiskZonesChecklist"),
      meta: { keepAlive: false },
    },
    {
      path: "/maxStudentsSettings",
      name: "maxStudentsSettings",
      props: true,
      component: () => import("./components/schoolPass/maxStudentsSettings"),
      meta: { keepAlive: false },
    },
    {
      path: "/Users",
      name: "Users",
      props: true,
      component: () => import("./components/Users"),
      meta: { keepAlive: false },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentUser = localStorage.getItem("user");

  // Белый список путей, которые доступны БЕЗ входа
  const publicPaths = ["/", "/policy"];

  if (publicPaths.includes(to.path)) {
    next();
    return;
  }

  if (currentUser === null) {
    next({ path: "/" });
    return;
  }

  next();
});

export default router;
